import React, { useState, useRef } from 'react';
import { Button } from '@pattern-library/buttons';
import Modal from '@pattern-library/modal';
import axios from 'axios';

const defaultProps = {
    isPending: false
};

function SchwabPCRAModal(props) {
    const [isModalActive, setIsModalActive] = useState(false);
    const triggerButtonRef = useRef();
    const [isLoading, setIsLoading] = useState(false);

    const [actionURL, setActionURL] = useState(null);
    const [APIID, setAPIID] = useState(null);
    const [DATA, setDATA] = useState(null);
    const [APIENC, setAPIENC] = useState(null);

    const onButtonClick = () => {
        setIsModalActive(true);
    };

    const OnFormSubmit = () => {
        setIsLoading(true);
        axios
            .post('/Participant/investment/SelfDirectedBrokerageAccountOpen?p=' + props.NavigationKey)
            .then(response => {
                var data = response.data;
                setActionURL(data.ACTION);
                setAPIID(data.APIID);
                setDATA(data.DATA);
                setAPIENC(data.APIENC);
            })
            .catch(() => {
                setIsLoading(false);
            })
            .finally(() => {
                document.getElementById('FORM1').submit();
                setIsModalActive(false);
                setIsLoading(false);
            });
    };

    return (
        <>
            <Button
                clickHandler={onButtonClick}
                text="Open PCRA"
                buttonRef={triggerButtonRef}
                className="asc-btn--small"
                showLoading={isLoading}
                disabled={isLoading}
            />
            <Modal id="schwab-pcra-modal"
                closeModal={() => setIsModalActive(false)}
                hasFooter={false}
                hasFooterClose={false}
                isActive={isModalActive}
                headerText="Schwab Personal Choice Retirement Account® (PCRA)"
            >
                <form id="FORM1" name="form1" method="post" action={actionURL} target="_new">
                    <input type="hidden" name="API.ID" value={APIID} />
                    <input type="hidden" name="DATA" value={DATA} />
                    <input type="hidden" name="API.ENC" value={APIENC} />
                    <p>You are now leaving this website and will be entering a secure area of the Charles Schwab & Co., Inc. schwabpcra.com website.</p>
                    <p> Privacy</p>
                    <p>I acknowledge that by using the secured section of the PCRA website, Schwab will be gaining access to my
                        personal financial information. Information that I provide and that I authorize my Retirement Plan Provider to
                        provide by using the PCRA website and other Information provided by Schwab is subject to the use and
                        disclosure conditions outlined in Schwab's privacy policy at www.schwab.com/public/schwab/nn/legal_compliance/privacy.</p>
                    <p>I agree that, when I click on the "Continue" button, my agreement or consent will be legally binding and enforceable and the legal equivalent of my handwritten signature.</p>
                    <br />
                    <div className="asc-flex-btn-group asc-flex-btn-group--center">
                        <input className="asc-btn--small asc-mb-2" type="button" value="Continue" onClick={() => OnFormSubmit()} />
                    </div>
                </form>
            </Modal>
        </>
    );
}

SchwabPCRAModal.defaultProps = defaultProps;
export default SchwabPCRAModal;